import React from 'react';
import { useFormikContext } from 'formik';

import RadioButton from '@components/form/RadioButton';
import SociollaErrorMessage from './SociollaErrorMessage';

// eslint-disable-next-line react/prop-types
function SociollaRadioButton({ name, onChange, ...otherProps }) {
  const { setFieldValue, errors, touched, values } = useFormikContext();

  return (
    <>
      <RadioButton
        onChange={async (value) => {
          await setFieldValue(name, value);
          if (onChange) {
            onChange(value);
          }
        }}
        value={values[name]}
        {...otherProps}
      />
      <SociollaErrorMessage error={errors[name]} visible={touched[name]} />
    </>
  );
}

export default SociollaRadioButton;
